import { Link, useLocation } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const location = useLocation();

  useSeo({ title: "页面不存在 - 顽皮的女朋友" });

  return (
    <div className="px-4 md:px-6 py-24 flex flex-col items-center text-center min-h-[60vh] justify-center">
      <span className="font-heading font-bold text-7xl md:text-9xl text-primary-100 select-none">
        404
      </span>
      <h1 className="mt-4 font-heading font-semibold text-xl md:text-2xl text-foreground-950">
        抱歉，没有找到这个页面
      </h1>
      <p className="mt-2 text-sm text-foreground-500">
        访问的地址 {location.pathname} 不存在或已被移除。
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="h-11 px-6 inline-flex items-center gap-2 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-heading text-sm tracking-wide hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/category"
          className="h-11 px-6 inline-flex items-center gap-2 rounded-md border border-background-300 text-foreground-700 font-heading text-sm tracking-wide hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-layout-grid-line"></i>
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}